import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bf-checkout" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex mb-3"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pe-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle text-warning" })
], -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Bitte beachte: Du kaufst diese Kurskarte für den Standort ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(", die Einlösung ist demnach nur hier möglich.")
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 1,
  class: "d-flex mb-3"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "pe-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo text-success" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", { class: "text-success" }, "Präventionskurs:"),
  /*#__PURE__*/_createTextVNode(" Jede gesetzliche Krankenkasse unterstützt Dich in Deinem sportlichen Vorhaben mit bis zu 100% Rückerstattung der Kursgebühr. ")
], -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "checkout-steps-nav" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right" })
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right" })
], -1)
const _hoisted_15 = { class: "checkout-steps mt-4" }
const _hoisted_16 = { class: "checkout-steps__step" }
const _hoisted_17 = { class: "d-flex justify-content-end mt-4" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Fortfahren ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-right" }, null, -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "checkout-steps__step" }
const _hoisted_22 = { class: "d-flex justify-content-end mt-4" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Fortfahren ")
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-right" }, null, -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "checkout-steps__step" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductCard = _resolveComponent("ProductCard")!
  const _component_StepsNavEntry = _resolveComponent("StepsNavEntry")!
  const _component_StepUserGuest = _resolveComponent("StepUserGuest")!
  const _component_StepVoucher = _resolveComponent("StepVoucher")!
  const _component_StepPayment = _resolveComponent("StepPayment")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.product.type !== 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", null, [
            (_ctx.regionName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("b", null, _toDisplayString(_ctx.regionName), 1),
                  _hoisted_6
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, "Bitte beachte: Du kaufst diese Kurskarte für einen bestimmten Standort, die Einlösung ist demnach nur dort möglich."))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.product.type === 2 && (_ctx.product.course?.mode === 1 && _ctx.product.course?.insurance_certified))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
      : _createCommentVNode("", true),
    _createVNode(_component_ProductCard, {
      product: _ctx.product,
      "apply-discount-percent": _ctx.stepsData?.voucher?.redeemVoucher?.discount_percentage || 0,
      classes: {'mb-5': true}
    }, null, 8, ["product", "apply-discount-percent"]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_StepsNavEntry, {
        step: 0,
        "is-accessible": _ctx.highestValidStep >= -1,
        "is-current": _ctx.currentStep === 0,
        title: "Käufer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchToStep(0)))
      }, null, 8, ["is-accessible", "is-current"]),
      _hoisted_13,
      _createVNode(_component_StepsNavEntry, {
        step: 1,
        "is-accessible": _ctx.highestValidStep >= 0,
        "is-current": _ctx.currentStep === 1,
        title: "Gutschein",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchToStep(1)))
      }, null, 8, ["is-accessible", "is-current"]),
      _hoisted_14,
      _createVNode(_component_StepsNavEntry, {
        step: 2,
        "is-accessible": _ctx.highestValidStep >= 1,
        "is-current": _ctx.currentStep === 2,
        title: "Zahlung",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchToStep(2)))
      }, null, 8, ["is-accessible", "is-current"])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _withDirectives(_createElementVNode("div", _hoisted_16, [
        _createVNode(_component_StepUserGuest, {
          "is-current": _ctx.currentStep === 0,
          onData: _cache[3] || (_cache[3] = (stepData) => _ctx.stepsData.userGuest = stepData),
          onValid: _cache[4] || (_cache[4] = ($event: any) => (_ctx.stepsState[0] = 'valid')),
          onInvalid: _cache[5] || (_cache[5] = ($event: any) => (_ctx.stepsState[0] = 'invalid'))
        }, null, 8, ["is-current"]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("a", {
            class: _normalizeClass(["btn btn-lg btn-primary", {disabled: _ctx.highestValidStep < 0}]),
            href: "#",
            onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToNextStep && _ctx.goToNextStep(...args)), ["prevent"]))
          }, _hoisted_20, 2)
        ])
      ], 512), [
        [_vShow, _ctx.currentStep === 0]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_21, [
        _createVNode(_component_StepVoucher, {
          "is-current": _ctx.currentStep === 1,
          product: _ctx.product,
          onData: _cache[7] || (_cache[7] = (stepData) => _ctx.stepsData.voucher = stepData),
          onValid: _cache[8] || (_cache[8] = ($event: any) => (_ctx.stepsState[1] = 'valid')),
          onInvalid: _cache[9] || (_cache[9] = ($event: any) => (_ctx.stepsState[1] = 'invalid'))
        }, null, 8, ["is-current", "product"]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("a", {
            class: _normalizeClass(["btn btn-lg btn-primary", {disabled: _ctx.highestValidStep < 1}]),
            href: "#",
            onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToNextStep && _ctx.goToNextStep(...args)), ["prevent"]))
          }, _hoisted_25, 2)
        ])
      ], 512), [
        [_vShow, _ctx.currentStep === 1]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_26, [
        _createVNode(_component_StepPayment, {
          "is-current": _ctx.currentStep === 2,
          product: _ctx.product,
          "additional-order-data": _ctx.stepsData,
          onSuccess: _ctx.onPaymentSuccess
        }, null, 8, ["is-current", "product", "additional-order-data", "onSuccess"])
      ], 512), [
        [_vShow, _ctx.currentStep === 2]
      ])
    ])
  ]))
}